import { OrganisationTypeConstants } from "../../../../../../../constants";
import { useAuth } from "../../../../../../../useAuth";
import { AssignResponsibleOwnerModal, ProjectAccessInviteFields } from "../../../../../../../widget";
import { SendAccessInvitationModal } from "../../../../../../developer/components";
import { useInviteForm } from "./useInviteForm";

export const InviteForm = (): JSX.Element => {
  const { currentUserType } = useAuth();
  const {
    selection,
    onSelectionChange,
    organisationTypeOptions,
    organisationOptions,
    onOrganisationSearch,
    accessOptions,
    showMakeResponsibleOwner,
    showExistingDeveloperAction,
    existingDeveloperActionOptions,
    existingDeveloperName,
    onSubmit,
    onCancel,
    onSendInvitation,
    showSendInvitationModal,
    onCloseSendInvitationModal,
    showAssignResponsibleOwnerModal,
    selectedOrganisationName,
    currentResponsibleOwnerName,
    onCloseAssignResponsibleOwnerModal,
    isOnSubmitLoading,
    errors,
  } = useInviteForm();
  const isAssetManager = currentUserType === OrganisationTypeConstants.ASSET_MANAGER;

  return (
    <>
      <ProjectAccessInviteFields
        organisationTypeOptions={organisationTypeOptions}
        organisationOptions={organisationOptions}
        onOrganisationSearch={onOrganisationSearch}
        accessOptions={accessOptions}
        value={selection}
        onChange={onSelectionChange}
        onSubmit={onSubmit}
        onCancel={onCancel}
        showMakeResponsibleOwner={showMakeResponsibleOwner}
        showExistingDeveloperAction={showExistingDeveloperAction}
        existingDeveloperActionOptions={existingDeveloperActionOptions}
        existingDeveloperName={existingDeveloperName}
        createNewOrganisation={false}
        isLoading={isOnSubmitLoading}
        corners={isAssetManager ? "rounded" : "default"}
        errors={errors}
      />
      <SendAccessInvitationModal
        show={showSendInvitationModal}
        onSendAccessInvitation={onSendInvitation}
        closeModal={onCloseSendInvitationModal}
      />
      <AssignResponsibleOwnerModal
        show={showAssignResponsibleOwnerModal}
        newOwnerName={selectedOrganisationName}
        currentOwnerName={currentResponsibleOwnerName}
        onConfirm={onSendInvitation}
        onCancel={onCloseAssignResponsibleOwnerModal}
        isLoading={isOnSubmitLoading}
      />
    </>
  );
};
